import React from 'react';

/**
 * RepairTypeBadge Component
 * Displays a small badge indicating the repair type (Wash, Touch-up, Recoat)
 */
const RepairTypeBadge = ({ repairType, className = '' }) => {
  const getBadgeConfig = (type) => {
    switch (type?.toLowerCase()) {
      case 'wash':
        return {
          label: 'WA',
          fullName: 'Wash',
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800',
          borderColor: 'border-blue-300'
        };
      case 'touchup':
      case 'touch-up':
        return {
          label: 'TO',
          fullName: 'Touch-up',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          borderColor: 'border-yellow-300'
        };
      case 'overcoat':
      case 'oc':
        return {
          label: 'OC',
          fullName: 'Overcoat',
          bgColor: 'bg-amber-100',
          textColor: 'text-amber-800',
          borderColor: 'border-amber-300'
        };
      case 'recoat':
      case 'full':
        return {
          label: 'RE',
          fullName: 'Recoat/Full Repair',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          borderColor: 'border-green-300'
        };
      default:
        return {
          label: '?',
          fullName: 'Unknown',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          borderColor: 'border-gray-300'
        };
    }
  };

  const config = getBadgeConfig(repairType);

  if (!repairType) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-semibold border ${config.bgColor} ${config.textColor} ${config.borderColor} ${className}`}
      title={config.fullName}
    >
      {config.label}
    </span>
  );
};

export default RepairTypeBadge;

